"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ButtonOld = require("./old/Button.old.types");
var _ButtonOld2 = require("./old/Button.old.utils");
var _Button = _interopRequireDefault(require("./new/Button"));
var _excluded = ["children", "disabled", "fullWidth", "icon", "isLoading", "variant", "chevron", "dropdown", "size", "href"];
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
/*
 * Only code here when you need to adapt specific props to be passed from old usage to the new usage of the button
 * This is not meant to be used as the main case and you should always refer to the component that's inside /new folder
 */
var ButtonMiddleware = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _VARIANT_TRANSLATIONS;
  var children = _ref.children,
    disabled = _ref.disabled,
    fullWidth = _ref.fullWidth,
    Icon = _ref.icon,
    isLoading = _ref.isLoading,
    variant = _ref.variant,
    chevron = _ref.chevron,
    dropdown = _ref.dropdown,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    href = _ref.href,
    props = _objectWithoutProperties(_ref, _excluded);
  (0, _react.useEffect)(function () {
    (0, _ButtonOld2.validatePropsUsage)({
      chevron: chevron,
      dropdown: dropdown,
      icon: Icon,
      variant: variant
    });
  }, []);
  var finalVariant = (0, _ButtonOld2.getFinalVariant)(variant);
  var VARIANT_TRANSLATIONS = (_VARIANT_TRANSLATIONS = {}, _defineProperty(_VARIANT_TRANSLATIONS, _ButtonOld.Variant.DEFAULT, 'primary'), _defineProperty(_VARIANT_TRANSLATIONS, _ButtonOld.Variant.DESTRUCTIVE, 'destructive'), _defineProperty(_VARIANT_TRANSLATIONS, _ButtonOld.Variant.PADDINGLESS, 'subtle'), _defineProperty(_VARIANT_TRANSLATIONS, _ButtonOld.Variant.QUIET, 'assistive'), _defineProperty(_VARIANT_TRANSLATIONS, _ButtonOld.Variant.SPECIAL, 'primary'), _defineProperty(_VARIANT_TRANSLATIONS, _ButtonOld.Variant.DEFAULT_INVERSE, 'primary'), _defineProperty(_VARIANT_TRANSLATIONS, _ButtonOld.Variant.DESTRUCTIVE_PADDINGLESS, 'destructiveSubtle'), _defineProperty(_VARIANT_TRANSLATIONS, _ButtonOld.Variant.PADDINGLESS_DESTRUCTIVE, 'destructiveSubtle'), _defineProperty(_VARIANT_TRANSLATIONS, _ButtonOld.Variant.QUIET_DESTRUCTIVE, 'destructiveAssistive'), _defineProperty(_VARIANT_TRANSLATIONS, _ButtonOld.Variant.QUIET_INVERSE, 'assistive'), _defineProperty(_VARIANT_TRANSLATIONS, _ButtonOld.Variant.PADDINGLESS_INVERSE, 'subtle'), _VARIANT_TRANSLATIONS);
  var inverse = [_ButtonOld.Variant.QUIET_INVERSE, _ButtonOld.Variant.PADDINGLESS_INVERSE, _ButtonOld.Variant.DEFAULT_INVERSE].includes(finalVariant);
  var newVariant = VARIANT_TRANSLATIONS[finalVariant];
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    variant: newVariant,
    inverse: inverse,
    showChevronDown: dropdown,
    showArrowForward: chevron,
    disabled: disabled,
    fullWidth: fullWidth,
    loading: isLoading,
    leftIcon: Icon,
    href: href,
    ref: ref,
    size: size
  }, props), children);
});
var _default = exports["default"] = ButtonMiddleware;